import environment from '../../../common/environment';
import { ActionStatus } from '../../../common/constants/action-status';
import { CONNECT } from '../../../common/utils/util';
import { SHARPEN_WIDGET_TITLE } from '../constants/sharpen-page-type.constants';
import { SharpenSearchServiceProductData } from '../interfaces/sharpen-search-service-product-data.interface';
import { StoreState } from '../../../store/store.interface';
import { SubscriptionProductData } from '../../subscription/add-to-cart/subscription-add-to-cart';
import { getCart, getCartStatus } from '../../cart/shop-cart/store/shop-cart.selectors';
import { getSharpenSearchServiceProductStatus } from '../store/sharpen-product-data.selector';
import { mapSharpenSearchServiceToSSubscriptionProductData } from '../mapping/sharpen-search-service-to-subscription-product-data.mapping';

export const isCartSuccess = (state: StoreState) => getCartStatus(state) === ActionStatus.succeeded;
export const isCartFailed = (state: StoreState) => getCartStatus(state) === ActionStatus.failed;

export const isSharpenSearchServiceProductSuccess = (state: StoreState) =>
  getSharpenSearchServiceProductStatus(state) === ActionStatus.succeeded;
export const isSharpenSearchServiceProductFailed = (state: StoreState) =>
  getSharpenSearchServiceProductStatus(state) === ActionStatus.failed;

export function getSharpenWidgetTitle() {
  return SHARPEN_WIDGET_TITLE;
}

export function getPricingToShow(netPrice: string) {
  return `$${parseFloat(netPrice).toFixed(2)}`;
}

export function redirectToSharpenPDP(): string {
  return environment().mheducationUrl.concat('/highered/product/sharpen-mcgraw-hill.html');
}

export function isSharpenPlusBundle(state: StoreState, sharpenIsbnList?: string[]) {
  const cart = getCart(state);
  const products = cart?.products ?? [];

  if (products && products?.length === 1) {
    const tunnelProduct = products[0];

    // to be confirmed if we can add more than 1 product in case of EDOMS products
    if (
      (cart?.metaOfferId || tunnelProduct.productMetadata?.flow?.toLowerCase() === CONNECT) &&
      !tunnelProduct.productIdentifier?.isSharpenAdvantage &&
      !tunnelProduct.productIdentifier?.isSharpenCompanion &&
      !!tunnelProduct.productIdentifier?.isbn10 &&
      (sharpenIsbnList?.includes(tunnelProduct.productIdentifier.isbn10) ||
        sharpenIsbnList?.includes(tunnelProduct.productIdentifier.programSourceId ?? ''))
    ) {
      return true;
    }
  }

  return false;
}

/**
 * Maps and sort the offers from the Sharpen search service by duration in ascending order.
 *
 * If there are no offers, it returns an empty array.
 *
 * @param offers
 */
export function getSortedSharpenOffersByDuration(
  offers?: SharpenSearchServiceProductData[]
): SubscriptionProductData[] {
  if (!offers?.length) {
    return [];
  }

  return offers
    .map((data: SharpenSearchServiceProductData) => mapSharpenSearchServiceToSSubscriptionProductData(data))
    .sort((a: SubscriptionProductData, b: SubscriptionProductData) => Number(a.duration) - Number(b.duration));
}
